// @core/api/endpoints/project/list_project_members.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProjectMembersResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List project members
 * Returns all members of the project with their roles and join dates. Used for team views and assignment dropdowns.
 */
export async function ListProjectMembers(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProjectMembersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/members`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListProjectMembersResponse>(requestPath, { ...requestOptions, params });
}
